// Status cards broadcast to every front-page viewer (Video#broadcast,
// #broadcast_error) are the same HTML for all of them, so the server cannot
// leave out the controls a viewer may not use. Each such control carries
// data-vips-requires ("uploader": the video's uploader or an admin; "admin")
// and data-vips-uploader-id; the layout's vips-viewer-* meta tags say who is
// viewing. This removes the controls the viewer may not use. It is a
// courtesy only: the server refuses them anyway (VideoPolicy).
const readViewer = (doc) => ({
    id: doc.querySelector('meta[name="vips-viewer-id"]')?.content || null,
    admin: doc.querySelector('meta[name="vips-viewer-admin"]')?.content === "true",
});

const mayUse = (control, viewer) => {
    if (viewer.admin) return true;
    if (control.dataset.vipsRequires !== "uploader") return false;
    return viewer.id !== null && control.dataset.vipsUploaderId === viewer.id;
};

const removeControlsViewerMayNotUse = (root = document) => {
    const viewer = readViewer(root.ownerDocument || root);
    root.querySelectorAll("[data-vips-requires]").forEach((control) => {
        if (!mayUse(control, viewer)) control.remove();
    });
};

export default removeControlsViewerMayNotUse;
